const theme = {
  fontWeights: {
    normal: 300,
    bold: 700
  },

  // https://material-ui.com/customization/breakpoints/
  breakpoints: {
    xs: '0',
    sm: '600px',
    md: '960px',
    lg: '1280px',
    xl: '1920px'
  }
}

export default theme
